export function SkeletonLoader({ width = "w-full", height = "h-12" }) {
  return (
    <div
      className={`${width} ${height} bg-gray-700 rounded-lg animate-pulse`}
    />
  );
}
